import { connect } from 'react-redux';
import ProjectListComponent from 'components/feature/project-list/project-list-component';
import {
  fetchProjectList,
  softDeleteProject,
  restoreDeletedProject,
  permanentlyDeleteProject,
  setProjectFilterGeo,
  setAppliedSearchTerm,
  clearAppliedSearchTerm,
  setFirstProjectAsSelectedFromProjectList,
} from 'store/actions/project-list-actions';
import { setSelectedProjectFromProjectList } from 'store/actions/selected-project-actions';
import {
  getPinnedDetails,
  updatePinDetails,
  updateUnpinDetails,
} from 'store/actions/pinned-details-actions';

const mapStateToProps = ({ data }) => {
  const {
    projectList,
    pinnedDetails,
    selectedProject: { id },
    currentUser,
    opmService,
  } = data;
  return {
    projectList,
    pinnedDetails,
    selectedProjectID: id,
    currentUser: currentUser.data,
    stateData: data,
    isOpmDown: opmService?.isServiceDown ?? false,
  };
};

const mapDispatchToProps = {
  fetchProjectList,
  setSelectedProjectFromProjectList,
  setFirstProjectAsSelectedFromProjectList,
  softDeleteProject,
  restoreDeletedProject,
  permanentlyDeleteProject,
  setProjectFilterGeo,
  setAppliedSearchTerm,
  clearAppliedSearchTerm,
  getPinnedDetails,
  updatePinDetails,
  updateUnpinDetails,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ProjectListComponent);
